<template>
  <div class="olderBase">
    <el-row class="olderBase-a">
      <el-col class="marginten">
        <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
        <span style="vertical-align:middle;font-size:16px;margin-left:10px">长者基本情况</span>
      </el-col>
    </el-row>
    <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" prop="oldName">
            <el-input v-model.trim="addForm.oldName" auto-complete="off" maxlength="15" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号" prop="oldIdCard" ref="oldIdCard">
            <el-input v-model="addForm.oldIdCard" auto-complete="off" @change="changeIdCardAdd"
              class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="addForm.sex" placeholder="请选择" @change="changeSexAdd" class="width80">
              <el-option v-for="item in addsexoption" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="电话号码" prop="oldPhone">
            <el-input v-model="addForm.oldPhone" class="width80" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="社保/老年卡号" prop="oldmanNo">
            <el-input v-model.trim="addForm.oldmanNo" auto-complete="off" maxlength="20" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生年月" prop="birthday" class="date-style">
            <el-date-picker class="width80" type="date" placeholder="选择日期" v-model="addForm.birthday"
              :picker-options="pickerBirthday" @change="changeBirthdayAdd"></el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="民族" prop="nation">
            <el-select v-model="addForm.nation" placeholder="请选择" filterable class="width80">
              <el-option v-for="item in nations" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="籍贯" prop="ancestral">
            <el-input v-model.trim="addForm.ancestral" auto-complete="off" maxlength="20" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="政治面貌" prop="political">
            <el-select class="width80" v-model="addForm.political" placeholder="请选择">
              <el-option label="党员" value="党员"></el-option>
              <el-option label="群众" value="群众"></el-option>
              <el-option label="民主党派" value="民主党派"></el-option>
              <el-option label="无党派人士" value="无党派人士"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="社区(村)" prop="cardAddress">
            <el-input v-model.trim="addForm.cardAddress" auto-complete="off" maxlength="30" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="家庭住址" prop="oldAddress">
            <el-input v-model.trim="addForm.oldAddress" maxlength="60" class="width80">
              <i slot="suffix" class="el-input__icon el-icon-location-outline" @click="focusAdd"></i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="在院状态" prop="serviceType">
            <el-select v-model="addForm.serviceType" placeholder="请选择" class="width80">
              <el-option label="在院" value="1"></el-option>
              <el-option label="离院" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="残疾情况" prop="valid">
            <el-select class="width80" v-model="addForm.valid" placeholder="请选择">
              <el-option label="请选择" value="0"></el-option>
              <el-option label="无残疾" value="1"></el-option>
              <el-option label="轻度残疾" value="2"></el-option>
              <el-option label="中度残疾" value="3"></el-option>
              <el-option label="重度残疾" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="老人类别" prop="interest">
            <el-select class="width80" v-model="addForm.interest" placeholder="请选择">
              <el-option label="普通" value="普通"></el-option>
              <el-option label="高龄" value="高龄"></el-option>
              <el-option label="独居" value="独居"></el-option>
              <el-option label="残疾" value="残疾"></el-option>
              <el-option label="空巢" value="空巢"></el-option>
              <el-option label="特困对象" value="特困对象"></el-option>
              <el-option label="低保对象" value="低保对象"></el-option>
              <el-option label="半失能对象" value="半失能对象"></el-option>
              <el-option label="失能对象" value="失能对象"></el-option>
              <el-option label="其他类别" value="其他类别"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="当前补贴" prop="occupation">
            <el-select v-model="addForm.occupation" multiple class="width80" placeholder="请选择补贴">
              <el-option label="高龄补贴" value="高龄补贴"> </el-option>
              <el-option label="经济困难特殊老人补贴" value="经济困难特殊老人补贴"> </el-option>
              <el-option label="失能老人补贴" value="失能老人补贴"> </el-option>
              <el-option label="残疾人补贴" value="残疾人补贴"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="补贴金额" prop="oldMonIncome">
            <el-input v-model.trim="addForm.oldMonIncome" auto-complete="off" maxlength="30" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入院日期" prop="registryTime" class="date-style">
            <el-date-picker type="date" placeholder="入院日期" class="width80" value-format="yyyy-MM-dd"
              v-model="addForm.registryTime"></el-date-picker>
          </el-form-item>

        </el-col>
        <el-col :span="8">
          <el-form-item label="离院日期" prop="outReason" class="date-style">
            <el-date-picker type="date" placeholder="离院日期" class="width80" value-format="yyyy-MM-dd"
              v-model="addForm.outReason"></el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row style="height:52px;line-height:52px;">
        <el-row style="float: left;">
          <div style="display:inline-block">
            <el-form-item label="健康状况" prop="chronicDis" ref="chronicDis" class="chebox-tips">
              <template>
                <el-checkbox-group v-model="addForm.chronicDis" @change="chronicDisChange">
                  <el-checkbox class="height40" v-for="item in chronicDisArray" :label="item" :key="item"></el-checkbox>
                </el-checkbox-group>
              </template>
            </el-form-item>
          </div>
          <div class="crcDisOther" style="display:inline-block">
            <el-form-item prop="crcDisOther" ref="crcDisOther" style="width:0">
              <el-input v-if="otherAddCheck" v-model.trim="addForm.crcDisOther" class="otherAddCheck"></el-input>
            </el-form-item>
          </div>
        </el-row>
      </el-row>

      <el-row class="olderBase-a">
        <el-col class="marginten">
          <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px">联系人信息</span>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="联系人姓名" prop="egNamea">
            <el-input v-model.trim="addForm.egNamea" maxlength="15" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="egPhonea">
            <el-input v-model="addForm.egPhonea" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="与老人关系" prop="relationshipa">
            <el-select v-model="addForm.relationshipa" placeholder="请选择" class="width80">
              <el-option v-for="item in relationshipAoption" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="olderBase-a">
        <el-col class="marginten">
          <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px">长者入院合同</span>
        </el-col>
        <el-col :offset="1">
          <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card" :file-list="idCardFileList"
            :before-upload="beforeAvatarUploadPic" :http-request="uploadSectionFilePic1" :on-remove="handleRemovePic1"
            ref="imagePicA" :limit="100">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
      </el-row>

      <el-row class="olderBase-a">
        <el-col class="marginten">
          <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px">失能人员鉴定表</span>
        </el-col>
        <el-col :offset="1">
          <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card" :file-list="outFileList"
            :before-upload="beforeAvatarUploadPic" :http-request="uploadSectionFilePic2" :on-remove="handleRemovePic2"
            :limit="100">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
        <el-col class="marginten">
          <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px;">发票</span>
        </el-col>
        <el-col :offset="1">
          <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card" :file-list="otherFileList"
            :before-upload="beforeAvatarUploadPic" :http-request="uploadSectionFilePic3" :on-remove="handleRemovePic3"
            :limit="100">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>

      </el-row>

    </el-form>
    <div slot="footer" class="footer" align="center">
      <el-button type="warning" plain @click="back">返回</el-button>
      <el-button type="primary" plain @click="submitData" :loading="addLoading">完成</el-button>
    </div>
    <el-dialog class="el-dialog-map" :inline="true" title="家庭住址设置" :visible.sync="dialogFormVisibleSafe"
      @close="closeMap">
      <el-form label-width="100px" ref="addForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属乡镇" prop="cardAddress">
              <el-input v-model.trim="oldLocParam.cardAddress" auto-complete="off" maxlength="15"
                class="width80"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="oldAddress">
              <el-input v-model.trim="oldLocParam.oldAddress" auto-complete="off" maxlength="35"
                class="width80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="oldmanmap">
        <div id="container" ref="amap" class="map"></div>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="sureMap">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=RXWBZ-PDY64-ILJU6-XOEA6-ECH3J-PJBYJ"></script>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import service_loc from "@/assets/map/service_loc.png";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "@/utils/util.js";
import {
  validateOldId,
  validateEgPhonea,
  validategNamea,
  validateInput
} from "@/utils/validator.js";
export default {
  name: "olderBaseLeYi",
  data() {
    return {
      keyword: "", //模糊搜索
      oldmanId: "", //老人的id,用于请求数据获取老人的百度经纬度
      oldmanlng: "", //经度
      oldmanlat: "", //纬度
      postionMap: { lng: 0, lat: 0 }, //点击获取经纬度
      postionHuiXian: { lng: 0, lat: 0 }, //回显的经纬度坐标
      add: { jd: "", wd: "", siteName: "", site: "" }, //添加的mark
      showMark: false, //Mark点显示隐藏
      oldDetail:{},
      oldLocParam:{
        oldAddress:"",
        cardAddress:"",
        oldmanId:"",
        oldAddressBdGps:"",
      },
      idCardFileList:[],
      outFileList:[],
      otherFileList:[],
      showMarkHuiXian: false, //修改回显mark点的提示
      dialogFormVisibleSafe: false, //选择老人的家庭住址的模态框
      center: { lng: 0, lat: 0 }, //中心点
      zoom: 3, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: {
              hue: "#007fff",
              saturation: 89
            }
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff"
            }
          }
        ]
      },
      pickerBirthday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      //form表单的数据源
      addForm: {
        oldName: "",
        sex: "",
        birthday: "",
        oldIdCard: "",
        oldPhone: "",
        oldmanNo: "",
        oldAddress: "",
        cardAddress: "",
        registryTime: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        economicSource: "",
        oldMonIncome: "",
        serviceType: 0,
        oldEctLel: "",
        chronicDis: [],
        crcDisOther: "", //慢性病 其他 input框的值
        egNamea: "",
        egPhonea: "",
        relationshipa: "",
        relationshipb: -1,
        egNameb: "",
        egPhoneb: "",
        egaIdCard: "",
        egaAddress: "",
        // oldHeadPicId:'',
        mStatus: "",
        nation: "",
        ancestral: "",
        political: "",
        valid: "1",
        xunhu: "",
        qiaomen: "",
        inStatus: "",
        demand: "",
        interaction: "",
        interest: "",
        activities: "",
        occupation: "",
        consumption: ""

      },
      //form表单的正则验证
      addFormRules: {
        // oldName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        oldName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { required: true, validator: validateInput, trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1到 10 位的字符" }
        ], //by guo 2019-11-26-13:04修改
        sex: [{ required: true, message: "请选择老人性别", trigger: "change" }],
        oldIdCard: [
          { required: true, validator: validateOldId, trigger: "blur" }
        ],
        serviceType: [{
          required: true, message: "请选择老人类型", trigger: "change"
        }],
        oldPhone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },

        ],
        oldAddress: [
          { required: true, message: "请输入老人家庭住址", trigger: "blur" }
        ],

        chronicDis: [
          { required: false, message: "请选择健康状况", trigger: "change" }
        ],
        crcDisOther: [
          { required: true, message: "请输入其他信息", trigger: "blur" },
          { min: 1, max: 15, message: "长度为1-15位的字符", trigger: "blur" }
        ],
        egPhonea: [
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        egPhoneb: [
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        birthday: [
          { required: true, message: "请选择出生年月日", trigger: "change" }
        ]
      },
      //健康状况
      chronicDisArray: [
        "高血压",
        "糖尿病",
        "高血脂",
        "心脏病",
        "风湿病",
        "其他"
      ],
      //健康状况  其他 是否选中
      otherAddCheck: false,
      //性别
      addsexoption: [
        {
          value: 0,
          label: "男"
        },
        {
          value: 1,
          label: "女"
        }
      ],
      oldTypeoption: [
        {
          value: 0,
          label: "居家"
        },
        {
          value: 1,
          label: "入院"
        }
      ],
      nations: [], //民族
      //婚姻
      weddingStatus: [
        {
          label: "未婚",
          value: 1
        },
        {
          label: "已婚",
          value: 2
        },
        {
          label: "丧偶",
          value: 3
        },
        {
          label: "离异",
          value: 4
        },
        {
          label: "未说明婚姻状况",
          value: 5
        }
      ],
      //文化程度
      educationoption: [
        {
          value: 1,
          label: "无 "
        },
        {
          value: 2,
          label: "文盲"
        },
        {
          value: 3,
          label: "小学"
        },
        {
          value: 4,
          label: "初中"
        },
        {
          value: 5,
          label: "高中"
        },
        {
          value: 6,
          label: "大专及以上"
        }
      ],
      //经济来源
      economicSourceDisabled: false,
      economicoption: [
        {
          value: 1,
          label: "无"
        },
        {
          value: 7,
          label: "自有存款"
        },
        {
          value: 2,
          label: "低保"
        },
        {
          value: 3,
          label: "低保边缘户"
        },
        {
          value: 4,
          label: "退休金/养老金"
        },
        {
          value: 5,
          label: "子女补贴"
        },
        {
          value: 6,
          label: "亲友资助"
        }
      ],
      //月收入
      monthIncome: false,
      monthlyincomeoption: [
        {
          value: 0,
          label: "1000以下"
        },
        {
          value: 1,
          label: "2000-4000"
        },
        {
          value: 2,
          label: "4000-6000"
        },
        {
          value: 3,
          label: "6000-8000"
        },
        {
          value: 4,
          label: "8000-1.5W"
        },
        {
          value: 5,
          label: "1.5W+"
        }
      ],
      //与老人关系a
      relationshipAoption: [
        {
          value: 1,
          label: "子女"
        },
        {
          value: 2,
          label: "兄弟姐妹"
        },
        {
          value: 3,
          label: "旁系亲属"
        },
        {
          value: 4,
          label: "朋友"
        },
        {
          value: 5,
          label: "其他"
        }
      ],
      //与老人关系b
      relationshipBoption: [
        {
          value: -1,
          label: "请选择"
        },
        {
          value: 1,
          label: "子女"
        },
        {
          value: 2,
          label: "兄弟姐妹"
        },
        {
          value: 3,
          label: "旁系亲属"
        },
        {
          value: 4,
          label: "朋友"
        },
        {
          value: 5,
          label: "其他"
        }
      ],
      addLoading: false, //点击下一步提交数据的loading 默认为false
      BMap: "",
      map: ""
    };
  },
  methods: {
    changeIdCardAdd(val) {
      console.log(typeof val);
      if (val.length == 15) {
        console.log(val.substring(14, val.length));
        var re2 = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit2 = val.match(re2); //检查生日日期是否正确  15位
        var strIdCard = val.substring(14, val.length);
        var birthday =
          19 +
          val.substring(6, 8) +
          "-" +
          val.substring(8, 10) +
          "-" +
          val.substring(10, 12);
        if (arrSplit2 != null) {
          if (parseInt(arrSplit2[2].substr(1)) > 0) {
            arrSplit2[2] = "19" + arrSplit2[2];
          } else {
            arrSplit2[2] = "20" + arrSplit2[2];
          }
          var check15 = util.formatDate.YearMonthDayValidate(
            arrSplit2[2],
            arrSplit2[3],
            arrSplit2[4]
          );
          console.log(check15);
        }
        if (check15) {
          this.addForm.birthday = birthday;
          this.$refs["oldIdCard"].clearValidate();
        } else {
          this.addForm.sex = "";
          this.addForm.birthday = "";
        }
        if (strIdCard % 2 == 0) {
          this.addForm.sex = 1;
        } else {
          this.addForm.sex = 0;
        }
      } else if (val.length == 18) {
        var re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        //also re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arrSplit = val.match(re); //检查生日日期是否正确  18位
        var newStrIdCard = val.substring(16, 17);
        var newbirthday =
          val.substring(6, 10) +
          "-" +
          val.substring(10, 12) +
          "-" +
          val.substring(12, 14);
        if (arrSplit != null) {
          var check18 = util.formatDate.YearMonthDayValidate(
            arrSplit[2],
            arrSplit[3],
            arrSplit[4]
          );
        }
        if (check18) {
          this.addForm.birthday = newbirthday;
          this.$refs["oldIdCard"].clearValidate();
        } else {
          this.addForm.sex = "";
          this.addForm.birthday = "";
        }
        if (newStrIdCard % 2 == 0) {
          this.addForm.sex = 1;
        } else {
          this.addForm.sex = 0;
        }
      } else {
        this.addForm.sex = "";
        this.addForm.birthday = "";
      }
      this.queryIdCardRepet(val);
    },

    /*
      查询老人身份证是否已经存在
    */
    queryIdCardRepet(oldIdCard) {
      let params = new Object();
      params.oldIdCard = oldIdCard;
      this.$postJson("omc/Oldman/queryIdCardRepet", params).then(res => {
        if (res.code == 200) {
          if (res.result.result == true && res.result.oldManId != null) {
            var hospitalType = sessionStorage.getItem("hospitalType");
            //hospitalType==4 乐怡入院的新增   hospitalType==5乐怡入院的修改
            if (hospitalType == 4) {
              this.$confirm(
                "老人身份证已经存在,是否回显老人基本信息?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  center: true
                }
              )
                .then(() => {
                  this.selectOldManSupByOld(res.result.oldManId);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消"
                  });
                });
            } else {
              // this.$message({message:"该身份证已经存在",type:"error"});
            }
          }
        }
      });
    },

    //新增老人时 选取性别
    changeSexAdd(val) {
      console.log(val);
      this.addForm.sex = val;
    },

    //新增老人时 选取生日
    changeBirthdayAdd(val) {
      console.log(val);
      this.addForm.birthday = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd"
      );
      console.log(this.addForm.birthday);
    },
    uploadSectionFilePic1(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.idCardFileList.push({
              url:res.result
            })
            console.log(this.idCardFileList);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    uploadSectionFilePic2(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.outFileList.push({
              url:res.result
            })
            console.log(this.outFileList);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    uploadSectionFilePic3(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.otherFileList.push({
              url:res.result
            })
            console.log(this.otherFileList);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    //删除身份证截图
    handleRemovePic1(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      for (let i = 0; i < this.idCardFileList.length; i++) {
          if (file.url == this.idCardFileList[i].url) {
            this.idCardFileList.splice(i, 1);
          }
      }
    },
    handleRemovePic2(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      for (let i = 0; i < this.outFileList.length; i++) {
          if (file.url == this.outFileList[i].url) {
            this.outFileList.splice(i, 1);
          }
      }
    },
    handleRemovePic3(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      for (let i = 0; i < this.otherFileList.length; i++) {
          if (file.url == this.otherFileList[i].url) {
            this.otherFileList.splice(i, 1);
          }
      }
    },
    /*
      身份证截图的验证和取值
    */
    beforeAvatarUploadPic(file) {
      //this.idCardPicList.push(file);//获取值，用于删除时的比对  by guo 2020-6-30-16:10注释  换到下面判断才能添加
      let isPNG = false;
      let isImage = false; //by guo 2020-6-30-16:10添加
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 16;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 16MB");
      }
      return isPNG && isLt2M && isImage;
    },

    //健康状况 其他  是否被选中
    controlcrcAddDisOther(chronicDis) {
      var haveFlag = false;
      for (var i = 0; i < chronicDis.length; i++) {
        if (chronicDis[i] == "其他") {
          haveFlag = true;
        }
      }
      if (haveFlag) {
        this.otherAddCheck = true;
        this.addFormRules.crcDisOther = [
          { required: true, message: "请输入其他信息", trigger: "blur" },
          { min: 1, max: 15, message: "长度为1-15位的字符", trigger: "blur" }
        ];
      } else {
        this.otherAddCheck = false;
        //this.addForm.crcDisOther = "";
        this.$set(this.addForm, "crcDisOther", ""); //by guo 2019-11-23-13:43修改  不能直接用等号赋值，用等号数据不会改变的
        this.$refs["crcDisOther"].clearValidate(); //清除其他的input的验证
        this.addFormRules.crcDisOther = [];
        //先要判断是否存在  存在才清除验证
        this.$nextTick(() => {
          if (this.$refs["chronicDis"] != undefined || null) {
            this.$refs["chronicDis"].clearValidate(); //其他的radio不选时，清除正则验证
          }
        });
      }
    },

    //健康状况
    chronicDisChange(val) {
      console.log(val);
      this.addForm.chronicDis = val;
      this.controlcrcAddDisOther(this.addForm.chronicDis);
    },

    //打开家庭住址dialog模态框
    focusAdd() {
      console.log(this.oldDetail)
      if(this.oldDetail == null || this.oldDetail.oldmanId == null || this.oldDetail.oldmanId == ''){
        return;
      }
      this.oldLocParam.oldmanId = this.oldDetail.oldmanId;
      this.oldLocParam.cardAddress = this.oldDetail.cardAddress;
      this.oldLocParam.oldAddress = this.oldDetail.oldAddress;
      this.oldLocParam.oldAddressBdGps = "";
      const _this = this
      AMapLoader.load({
        key: 'bb369d6617c417b4826cee55ac7ad116',
        version: '2.0',
        plugins: []
      }).then((AMap) => {
        //服务人员定位
        let oldLoc = [];
        if(this.oldDetail.oldAddressBdGps!=null && this.oldDetail.oldAddressBdGps.length > 5){
          oldLoc = this.oldDetail.oldAddressBdGps.split(",")
          oldLoc[0] = Number(oldLoc[0]);
          oldLoc[1] = Number(oldLoc[1]);
        }
        const map = new AMap.Map('container', {
            zoom: 15, // 初始化地图级别
            zooms: [5, 30], // 地图缩放范围
            // 可以设置初始化当前位置
            center: oldLoc
        })
        let marker = new AMap.Marker({
            position: oldLoc,
            icon: new AMap.Icon({            
	                image: service_loc,
	                size: new AMap.Size(32, 32),  //图标所处区域大小
	                imageSize: new AMap.Size(32,32) //图标大小
	          }),
            offset: new AMap.Pixel(-16, -32)
        });
        marker.setMap(map);
        map.add(marker)
        map.on('click',(e)=>{
          let markerPosition = [e.lnglat.lng,e.lnglat.lat];
          if(marker!=null){
            map.remove(marker);
          }
          _this.oldLocParam.oldAddressBdGps = e.lnglat.lng+","+e.lnglat.lat;
          marker = new AMap.Marker({
            position: markerPosition,
            icon: new AMap.Icon({            
	                image: service_loc,
	                size: new AMap.Size(32, 32),  //图标所处区域大小
	                imageSize: new AMap.Size(32,32) //图标大小
	          }),
            offset: new AMap.Pixel(-16, -32)
          });
          marker.setMap(map);
          map.add(marker)
        }) 
      })
      this.dialogFormVisibleSafe = true;
    },

    //点击地图里面的input搜素框输入搜索，获取所有搜索的地址的数组 []
    markersset(e) {
      console.log(e);
      //输入家庭住址时，让搜索的结果显示
      document.getElementById("bm-local-search").style.display = "block";
    },

    //点击搜索的结果，获取点击获取的地址
    infohtmlset(e) {
      //先置空
      this.addForm.oldAddress = "";
      console.log(e);
      console.log(e.address);
      console.log(e.point);
      //把搜索选取的地址赋给外层dialog 家庭地址的input框
      this.addForm.oldAddress = e.address;
      //当选取了地址后，让其隐藏
      document.getElementById("bm-local-search").style.display = "none";
    },

    //点击地图dialog叉号关闭 重置
    closeMap() {
      console.log("aaa");
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog ,input框自动聚焦 比较友好
      let inputelementAdd = document.getElementById("oldAddressAdd");
      if (inputelementAdd != null) {
        //判断一下 因为编辑时打开地图时此值不存在的
        inputelementAdd.focus();
      }
      let inputelement = document.getElementById("oldAddress");
      if (inputelement != null) {
        //判断一下 因为新增时打开地图时此值不存在的
        inputelement.focus();
      }
    },

    //点击地图，记住地图选取的地址，清除上次点击的位置
    sureMap() {
      let params = {
        oldmanId:this.oldLocParam.oldmanId,
        cardAddress: this.oldLocParam.cardAddress,
        oldAddress: this.oldLocParam.oldAddress,
        oldAddressBdGps: this.oldLocParam.oldAddressBdGps,
      }
      this.$postJson("omc/Oldman/updateXsOldLocation", params).then(res=>{
        this.selectOldManSupByOld(params.oldmanId);
        this.dialogFormVisibleSafe = false;
      })

    },

    //生成地图实例
    handler({ BMap, map }) {
      //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
      //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
      console.log(BMap, map);
      //武汉的经纬度 zoom为地图显示的比例
      this.center.lng = 114.31667;
      this.center.lat = 30.51667;
      this.zoom = 15;
      //  //获取定位的数据
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        r => {
          if (r.point) {
            console.log(r.point);
            this.center.lng = r.longitude;
            this.center.lat = r.latitude;
            var point = new BMap.Point(this.center.lng, this.center.lat); //用当前定位的经纬度查找省市区街道等信息
            let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
            console.log(this.center.lng);
            console.log(this.center.lat);
            geocoder.getLocation(r.point, rs => {
              console.log(rs.address); //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
              let markers = new BMap.Marker(r.point);
              console.log(markers);
              // map.addOverlay(markers); //添加
              map.panTo(r.point);
              map.centerAndZoom(r.point, 15);
            });
          }
        },
        { enableHighAccuracy: true }
      );
      //by guo 2019-11-17
      window.map = map;
      // 赋值，方便调用，本节被用到
      this.BMap = BMap;
      this.map = map;
    },

    //点击获取mark
    getPoint(e) {
      //点击地图获取一些信息，
      console.log(e);
      (this.postionHuiXian.lng = ""), //把会显得点去掉
        (this.postionHuiXian.lat = "");
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();
      // this.center.lng=e.point.lng;
      // this.center.lat=e.point.lat;
      console.log(e.point);
      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, rs => {
        this.add.site = rs.address;
        this.addForm.oldAddress = rs.address;
      });
    },

    //点击生成mark点的提示关闭
    infoWindowClose() {
      this.show = false;
    },

    //提示打开
    infoWindowOpen() {
      //这里有个问题纠结了很久，百度的信息窗口默认有个点击其他地方就消失的事件，我没有找到
      //并且信息窗口点击一次显示，一次消失
      //于是我加了一个100毫秒的定时器，保证每次点击地图都可以展示信息窗口
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    dealChronicDis() {
      var chronicDis = "";
      if (this.addForm.chronicDis.indexOf("高血压") != -1) {
        chronicDis = "1";
      } else {
        chronicDis = "0";
      }
      if (this.addForm.chronicDis.indexOf("糖尿病") != -1) {
        chronicDis = chronicDis + "-1";
      } else {
        chronicDis = chronicDis + "-0";
      }
      if (this.addForm.chronicDis.indexOf("心脏病") != -1) {
        chronicDis = chronicDis + "-1";
      } else {
        chronicDis = chronicDis + "-0";
      }
      if (this.addForm.chronicDis.indexOf("关节炎") != -1) {
        chronicDis = chronicDis + "-1";
      } else {
        chronicDis = chronicDis + "-0";
      }
      if (this.addForm.chronicDis.indexOf("风湿病") != -1) {
        chronicDis = chronicDis + "-1";
      } else {
        chronicDis = chronicDis + "-0";
      }
      if (this.addForm.chronicDis.indexOf("其他") != -1) {
        chronicDis = chronicDis + "-1";
      } else {
        chronicDis = chronicDis + "-0";
      }
      return chronicDis;
    },

    //点击下一步提交数据
    submitData() {
      if (this.otherAddCheck == false) {
        this.addFormRules.crcDisOther = [];
      } else {
        this.addFormRules.crcDisOther = [
          { required: true, message: "请输入其他信息", trigger: "blur" },
          { min: 1, max: 15, message: "长度为1-15位的字符", trigger: "blur" }
        ];
      }
      let that = this;
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let params = new Object();
          params = Object.assign({}, this.addForm);
          params.chronicDis = this.dealChronicDis(); //处理健康状况
          params.judgment = ((this.addForm.xunhu == 1 ? "1" : "0") + "-" + (this.addForm.qiaomen == 1 ? "1" : "0"));
          params.idCardPic = "";
          params.outPic = "";
          params.otherPic = "";
          this.idCardFileList.forEach(item=>{
            params.idCardPic = params.idCardPic+item.url+",";
          })
          this.outFileList.forEach(item=>{
            params.outPic = params.outPic+item.url+",";
          })
          this.otherFileList.forEach(item=>{
            params.otherPic = params.otherPic+item.url+",";
          })
          if(params.occupation!=null && params.occupation.length>0){
            params.occupation = params.occupation.join(",");
          }else{
            params.occupation = "";
          }
          var url = "omc/Oldman/addOldmanWithSupplement";
          console.log(url);
          this.addLoading = true;
          this.$postJson(url, params)
            .then(res => {
              console.log(res);
              this.addLoading = false;
              if (res.status || res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                if (this.oldmanId == null) {  //添加
                  this.changeOldStatus(this.addForm.oldIdCard);
                } else {
                  this.back();
                }
              } else {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "error"
              });
            });
        } else {
          this.$message({ message: "请检查红色项是否填写正确", type: "error" });
        }
      });
    },

    //获取老人的百度地图信息和入院时间
    getoldManBdGps(oldmanId) {
      let param = {
        oldmanId: oldmanId
      };
      console.log(param);
      this.$postForm("omc/Oldman/selectByOldId", param).then(res => {
        if (res.result != null) {
          this.oldDetail = res.result;
          console.log(res.result.oldAddressBdGps);
          this.addForm.ancestral = res.result.ancestral;
          this.addForm.political = res.result.political;
          this.addForm.cardAddress = res.result.cardAddress;
          if (res.result.inStatus != null) {
            this.addForm.inStatus = "" + res.result.inStatus;
          }
          this.addForm.demand = res.result.demand;
          if (res.result.interaction != null) {
            this.addForm.interaction = "" + res.result.interaction;
          }
          this.addForm.interest = res.result.interest;
          if(res.result.occupation != null){
            this.addForm.occupation = res.result.occupation.split(",");
          }
          this.addForm.activities = res.result.activities;
          this.addForm.consumption = res.result.consumption;
          if (res.result.judgment != null) {
            let judges = res.result.judgment.split("-");
            if (judges != null && judges.length > 1) {
              this.addForm.xunhu = judges[0];
              this.addForm.qiaomen = judges[1];
              console.log(this.addForm);
            }
          }
        }
      });
    },
    /*
      form表单数据回显
    */
    selectOldManSupByOld(oldmanId) {
      let params = new Object();
      params.oldmanId = oldmanId;
      this.$postForm("omc/Oldman/selectOldManSupByOld", params).then(res => {
        this.compactObj(res.result, this.isEmpty); //调用方法  过滤掉 '' null undefined 的数据
        //婚姻
        res.result.mStatus =
          res.result.mstatus == null ? "" : Number(res.result.mstatus);
        //relationshipa
        // res.result.occupation;
        // addForm.occupation
        if(res.result.occupation != null){
          this.addForm.occupation = res.result.occupation.split(",");
        }
        //idCardFileList
        if(res.result.idCardPic!=null){
          this.idCardFileList = [];
          res.result.idCardPic.split(",").forEach(item=>{
            if(item.length>5){
              this.idCardFileList.push({
              url:item
              })
            }
          })
        }
        if(res.result.otherPic!=null){
          this.otherFileList = [];
          res.result.otherPic.split(",").forEach(item=>{
            if(item.length>5){
              this.otherFileList.push({
              url:item
              })
            }
          })
        }
        if(res.result.outPic!=null){
          this.outFileList = [];
          res.result.outPic.split(",").forEach(item=>{
            if(item.length>5){
              this.outFileList.push({
              url:item
              })
            }
          })
        }

        //月收入
        res.result.oldMonIncome =
          res.result.oldMonIncome == null
            ? ""
            : Number(res.result.oldMonIncome);
        //健康状况
        var chronicDis = [];
        if (res.result.valid != null) {
          res.result.valid = "" + res.result.valid;
        }
        if (res.result.relationshipa == 0) {
          res.result.relationshipa = '';
        }
        if (res.result.chronicDis != null) {
          var disSplit = res.result.chronicDis.split("-");
          disSplit.forEach((item, index) => {
            switch (index) {
              case 0:
                if (item == 1) {
                  chronicDis.push("高血压");
                }
                break;
              case 1:
                if (item == 1) {
                  chronicDis.push("糖尿病");
                }
                break;
              case 2:
                if (item == 1) {
                  chronicDis.push("心脏病");
                }
                break;
              case 3:
                if (item == 1) {
                  chronicDis.push("关节炎");
                }
                break;
              case 4:
                if (item == 1) {
                  chronicDis.push("风湿病");
                }
                break;
              case 5:
                if (item == 1) {
                  chronicDis.push("其他");
                  this.otherAddCheck = true;
                } else {
                  this.otherAddCheck = false;
                }
                break;
            }
          });
        }
        console.log(res.result);
        this.addForm = Object.assign(this.addForm, res.result);
        this.addForm.chronicDis = chronicDis;
        console.log(this.addForm);
        this.getoldManBdGps(oldmanId);
      });
    },

    //查询老人是否已经评估
    changeOldStatus(oldIdCard) {
      let params = new Object();
      params.oldIdCard = oldIdCard;
      params.status = 1; //变成待评估状态
      this.$postForm("omc/Oldman/changeStatus", params).then(res => {
        if (res.code == 200) {
          this.$alert("登记成功", "提示", {
            confirmButtonText: "确定"
          }).then(() => {
            this.back();
          });
        }
      });
    },

    /**
     * 去除对象中所有符合条件的对象
     * @param {Object} obj 来源对象
     * @param {Function} fn 函数验证每个字段
     */
    compactObj(obj, fn) {
      for (var i in obj) {
        if (typeof obj[i] === "object") {
          this.compactObj(obj[i], fn);
        }
        if (fn(obj[i])) {
          delete obj[i];
        }
      }
    },

    /*
     *
     *
     * 删除空对象 删除'', null, undefined
     */
    isEmpty(object) {
      if (typeof object === "object") {
        for (var i in object) {
          return false;
        }
        return true;
      } else {
        return object === "" || object === null || object === undefined;
      }
    },

    //回退的方法
    popstate() {
      history.pushState(null, null, document.URL);
    },

    //禁止刷新的方法
    keydown(e) {
      //Ctrl+R ---刷新   F5 ---刷新   Ctrl+F5 ---强制刷新
      //(event.ctrlKey == true && k == 82) || (k == 116) || (event.ctrlKey == true && k == 116)
      if (
        e.keyCode == 32 ||
        (e.ctrlKey == true && e.keyCode == 82) ||
        e.keyCode == 116 ||
        (e.ctrlKey == true && e.keyCode == 116)
      ) {
        e.preventDefault();
        e.cancelBubble = false;
        e.returnValue = false;
        return false;
        //要做的其他事情
      }
    },

    /*
      在该页面防止浏览器点击后退按钮
    */
    fobiddenBack() {
      //防止页面后退
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.popstate, true);
      window.addEventListener("keydown", this.keydown, true);
      window.onbeforeunload = function () {
        window.event.returnValue = "阻止";
      };
    },

    //返回
    back() {
      bus.$emit("refreshResident",{});
      bus.$emit("close_current_tags");
    },
    // 初始化民族
    initialNations() {
    var nations = [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族"
      ];
      for (var i = 0; i < nations.length; i++) {
        var item = {};
        item.value = i;
        item.label = nations[i];
        this.nations.push(item);
      }
    }
  },
  created() {
    this.initialNations();
  },
  mounted() {
  },
  destroyed() {
    window.removeEventListener("popstate", this.popstate, true);
    window.removeEventListener("keydown", this.keydown, true);
  }
};
</script>
<style lang="scss" scoped>
.olderBase {
  background: #fff;

  .olderBase-a {
    height: 60px;
    line-height: 60px;
  }

  .height40 {
    height: 40px;
    line-height: 40px;
  }

  .width400 {
    width: 500px;
  }


  .width80 {
    width: 80%;
  }

  .footer {
    padding: 30px 0;
    background: #fff;
  }

  @media screen and (min-width:640px) and (max-width:999px) {
    .oldmanmap {
      margin: 0px;

      .map {
        width: 600px;
        height: 60vh;
      }
    }

    ::v-deep .el-dialog {
      width: 628px;
    }
  }

  @media screen and (min-width:1000px) and (max-width:1530px) {
    .oldmanmap {
      margin: 0px;

      .map {
        width: 800px;
        height: 60vh;
      }
    }

    ::v-deep .el-dialog {
      width: 828px;
    }
  }

  @media screen and (min-width:1531px) and (max-width:1920px) {
    .oldmanmap {
      margin: 0px;

      .map {
        width: 1000px;
        height: 60vh;
      }
    }

    ::v-deep .el-dialog {
      width: 1028px;
    }
  }

  @media screen and (min-width:1921px) and (max-width:5920px) {
    .oldmanmap {
      margin: 0px;

      .map {
        width: 1500px;
        height: 60vh;
      }
    }

    ::v-deep .el-dialog {
      width: 1528px;
    }
  }

  ::v-deep .crcDisOther {
    position: relative;
  }

  ::v-deep .otherAddCheck .el-input__inner {
    position: absolute;
    left: -80px;
    top: -20px;
    width: 256px;
  }

  ::v-deep .crcDisOther .el-form-item__error {
    width: 120px !important;
    position: absolute;
    top: 45px;
    left: -80px;
  }

  //地图插件·
  ::v-deep .BMap_stdMpCtrl {
    top: 50px !important;
  }

  ::v-deep .citylist_popup_main {
    margin-left: 45px;
  }

  //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }

  ::v-deep .el-dialog__body {
    padding: 10px !important;
  }

  ::v-deep .el-dialog-map {
    margin-top: -5%;

  }
}
</style>
